import * as React from 'react'
import Typography from '@mui/material/Typography'

interface ITitleProps {
  children: React.ReactNode
}

export default function TitleComponent({ children }: ITitleProps) {
  return (
    <Typography component="h2" variant="h6" color="primary" gutterBottom>
      {children}
    </Typography>
  )
}
